import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { getBasicConfig } from './apiClient'

export async function createBrightSignZip(): Promise<void> {
  const zip = new JSZip()
  const filenames = [
    'access-kit.png',
    'autorun.brs',
    'boot.brs',
    'syncPlayer.brs',
    'time.brs',
    'oscBuilder.brs',
    'oscParser.brs',
    'config.json',
    'init.json',
    'ak.features.json',
    'ak.version.json',
    'autozip.brs',
    'timeline.brs',
    'gpio.brs',
    'subtitler.brs',
    'subtitles.css',
    'subtitles.html']
  for (const filename of filenames) {
    const filecontent = await (await fetch(`https://raw.githubusercontent.com/access-kit/brightsign-sync/master/${filename}`)).text()
    const dataToZip = filename === 'config.json'
      ? await (await getBasicConfig()).text()
      : filecontent
    zip.file(filename, dataToZip)
  }
  zip.generateAsync({ type: 'blob' }).then((content) => {
    FileSaver.saveAs(content, 'autorun.zip')
  })
}
